import type { SliderProps } from '@mui/material/Slider';
import Slider from '@mui/material/Slider';
import classNames from 'clsx';
import type React from 'react';
import { Field, useForm } from 'react-final-form';

import styles from './Slide.module.scss';

interface OwnProps {
  id: string;
  min: number;
  max: number;
  tooltip?: boolean;
  customTooltip?: React.ElementType;
  marks?: boolean | SliderProps['marks'];
  disabled?: boolean;
}

type Props = OwnProps & SliderProps;

const Slide: React.FC<Props> = ({
  id,
  min,
  max,
  tooltip,
  customTooltip,
  marks,
  disabled,
  classes: incomingClasses = {},
  ...props
}) => {
  const form = useForm();
  const rootClass = classNames(styles.root, incomingClasses.root);
  const thumbClass = classNames(styles.thumb, incomingClasses.thumb);
  const markClass = classNames(styles.mark, incomingClasses.mark);
  const markLabelClass = classNames(styles.markLabel, incomingClasses.markLabel);
  const valueLabelClass = classNames(styles.valueLabel, incomingClasses.valueLabel);
  const trackClass = classNames(styles.track, incomingClasses.track);
  const railClass = classNames(styles.rail, incomingClasses.rail);

  return (
    <Field name={id}>
      {({ input: { value } }) => (
        <Slider
          id={id}
          min={min}
          max={max}
          value={value ? parseInt(value) : min}
          disabled={disabled}
          valueLabelDisplay={customTooltip || tooltip ? 'auto' : 'off'}
          slots={{ valueLabel: customTooltip }}
          marks={marks}
          defaultValue={min}
          onChange={(_, val) => {
            form.change(id, val);
          }}
          classes={{
            root: rootClass,
            thumb: thumbClass,
            mark: markClass,
            markLabel: markLabelClass,
            valueLabel: valueLabelClass,
            track: trackClass,
            rail: railClass
          }}
          {...props}
        />
      )}
    </Field>
  );
};

export default Slide;
